import React from 'react';

/**
 * WizardStepper - horizontal numbered progress indicator.
 *
 * Props:
 *   steps    Array<string|{label: string}>
 *   current  number  zero-based index of the current step
 */
export default function WizardStepper({ steps = [], current = 0 }) {
  if (!Array.isArray(steps) || steps.length === 0) return null;
  return (
    <ol className="billing-admin__wizard">
      {steps.map((s, i) => {
        const label = typeof s === 'string' ? s : s.label;
        let mod = '';
        if (i < current) mod = 'billing-admin__wizard-step--done';
        else if (i === current) mod = 'billing-admin__wizard-step--current';
        return (
          <li key={i} className={`billing-admin__wizard-step ${mod}`}>
            <span className="billing-admin__wizard-step-bubble">
              {i < current ? (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                i + 1
              )}
            </span>
            <span className="billing-admin__wizard-step-label">{label}</span>
            {i < steps.length - 1 && <span className="billing-admin__wizard-step-line" />}
          </li>
        );
      })}
    </ol>
  );
}
